module.exports = __webpack_public_path__ + "./docs/img/ios.373e59ec9d4ac51a0fc8079908403a02.svg";